function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 373.12 373.12"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M266.667 234.667h-16.96l-5.867-5.867c20.907-24.213 33.493-55.68 33.493-90.133C277.333 62.08 215.253 0 138.667 0S0 62.08 0 138.667s62.08 138.667 138.667 138.667c34.453 0 65.92-12.587 90.133-33.387l5.867 5.867v16.853L341.333 373.12l31.787-31.787-106.453-106.666zm-128 0c-53.013 0-96-42.987-96-96s42.987-96 96-96 96 42.987 96 96-42.987 96-96 96z"
})));